import React from "react";
import PropTypes from "prop-types"; // PropTypes for type checking
import { connect } from "react-redux"; // Redux connect for state management
import moment from "moment"; // Moment.js for date and time formatting
import { makeStyles, useTheme } from "@material-ui/core/styles"; // Material-UI styling utilities
import TableSortLabel from "@material-ui/core/TableSortLabel"; // Table sorting label
import MenuItem from "@material-ui/core/MenuItem"; // Menu item for dropdowns
import Select from "@material-ui/core/Select"; // Material-UI Select component
import { isArray } from "lodash"; // Lodash utility for array checks
import Table from "@material-ui/core/Table"; // Table component
import TableHead from "@material-ui/core/TableHead"; // Table header
import isEmpty from "lodash/isEmpty"; // Lodash utility for checking empty objects
import TableBody from "@material-ui/core/TableBody"; // Table body
import TableCell from "@material-ui/core/TableCell"; // Table cell
import TableContainer from "@material-ui/core/TableContainer"; // Table container
import TableFooter from "@material-ui/core/TableFooter"; // Table footer
import TablePagination from "@material-ui/core/TablePagination"; // Table pagination
import TableRow from "@material-ui/core/TableRow"; // Table row
import Paper from "@material-ui/core/Paper"; // Paper component for elevation
import IconButton from "@material-ui/core/IconButton"; // Icon button
import FirstPageIcon from "@material-ui/icons/FirstPage"; // First page icon for pagination
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft"; // Left arrow icon for pagination
import { Typography } from "@material-ui/core"; // Typography for text styling
import AppLoader from "components/AppLoader/Index"; // Custom loader component
import { useSnackbar } from "notistack"; // Snackbar for notifications
import noDataImage from "../../assets/img/noDataImage.png"; // Image for no data
import tableStyle from "../../assets/jss/material-dashboard-react/components/reportTables"; // Custom table styles
import {
  sendInviteApiCall,
  sendInviteManagerApiCall,
  managerActionsLink,
} from "../../actions/Operations"; // Redux actions for operations
import {
  getMerchantListData,
  getManagerListData,
  emptyReduxState,
  getManagerListDataByID,
  getManagerActionsData,
} from "../../Redux/Actions/merchantInformation"; // Redux actions for manager actions

// Custom styles for the table
const useStyles = makeStyles(tableStyle);

// Function to create table data
function createData(
  Business_Name,
  Business_Uid,
  Manager_name,
  Manager_uid,
  Email,
  Updated_date,
  Status_Code,
  UpdateMgId,
  UpdateBsId,
  uniqueId
) {
  return {
    Business_Name, // Business name
    Business_Uid, // Business UID
    Manager_name, // Manager name
    Manager_uid, // Manager UID
    Email, // Email address
    Updated_date, // Updated date
    Status_Code, // Status code
    UpdateMgId, // Manager ID for updates
    UpdateBsId, // Business ID for updates
    uniqueId, // Unique ID
  };
}

// Rows for the table
let rows = [];

// Pagination actions for the table
function TablePaginationActions(props) {
  const classes = useStyles();
  const theme = useTheme();

  const {
 count, page, rowsPerPage, onPageChange,
} = props;

  // Navigate to the first page
  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  // Navigate to the previous page
  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  // Navigate to the next page
  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  // Navigate to the last page
  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.rootPagination}>
      {/* First page button */}
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        variant="body2"
        aria-label="first page"
      >
        {theme.direction === "rtl" ? (
          <Typography>Last</Typography>
        ) : (
          <Typography variant="body2">First</Typography>
        )}
      </IconButton>
      {/* Previous page button */}
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <Typography>Previous</Typography>
        ) : (
          <Typography variant="body2">Previous</Typography>
        )}
      </IconButton>
      {/* Current page indicator */}
      <IconButton
        onClick={handleFirstPageButtonClick}
        aria-label="first page"
        className={classes.bottonPage}
      >
        <Typography variant="body2">{page ? page + 1 : 1}</Typography>
      </IconButton>
      {/* Next page button */}
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <Typography variant="body2">Next</Typography>
        )}
      </IconButton>
      {/* Last page button */}
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? (
          <FirstPageIcon />
        ) : (
          <Typography variant="body2">Last</Typography>
        )}
      </IconButton>
    </div>
  );
}

// Prop types for pagination actions
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function EnhancedTableHead(props) {
  const {
 classes, order, orderBy, onRequestSort,
} = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = [
    {
      id: "Business_Name",
      numeric: false,
      disablePadding: true,
      label: "Business Name",
      headClassName: classes.DBA_Name,
    },
    {
      id: "Business_Uid",
      numeric: false,
      disablePadding: true,
      label: "Business UID",
      headClassName: classes.DBA_Name,
    },
    {
      id: "Manager_name",
      numeric: false,
      disablePadding: false,
      label: "Manager Name",
      headClassName: classes.Assign_To,
    },
    {
      id: "Manager_uid",
      numeric: false,
      disablePadding: false,
      label: "Manager UID",
      headClassName: classes.Assign_To,
    },
    {
      id: "Business_Email",
      numeric: true,
      disablePadding: false,
      label: "Email Address",
      headClassName: classes.email,
    },
    {
      id: "Updated_date",
      numeric: true,
      disablePadding: false,
      label: "Updated Date",
      headClassName: classes.Phone,
    },
    {
      id: "Status_Code",
      numeric: false,
      disablePadding: false,
      label: "RTP Status",
      headClassName: classes.status,
    },
    {
      id: "Status_Code",
      numeric: false,
      disablePadding: false,
      label: "ACH Status",
      headClassName: classes.status,
    },
  ];

  return (
    <TableHead className={classes.tableHeader}>
      <TableRow>
        {headCells.map((headCell, index) => (
          <TableCell
            key={index}
            className={classes.cellTextHeaderOffer}
            align="left"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const dropdownStyles = makeStyles(() => ({
  select: {
    fontSize: "0.875rem",
  },
  menuPaper: {
    maxHeight: "100px",
  },
}));
const ManagerActions = (props) => {
  const dropdownClasses = dropdownStyles();
  const classes = useStyles();
  const [page, setPage] = React.useState(
    props.managerListData?.managerActionsData?.page
  );
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("Updated_date");
  const [selected, setSelected] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [id, setId] = React.useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = React.useState(false);
  const [openDropdownACH, setOpenDropdownACH] = React.useState({});
  const [openDropdownRTP, setOpenDropdownRTP] = React.useState({});
  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const idFromUrl = queryParams.get("id");
    setId(idFromUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const payload = {
      pageNo: page,
      recordPerPage: rowsPerPage,
      sortColumn: orderBy,
      sortOrder: order,
    };
    props.getManagerActionsData(payload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (props?.managerListData?.managerActionsData?.page !== page) {
      setPage(props?.managerListData?.managerActionsData?.page);
    }
    if (props?.managerListData?.managerActionsData?.limit !== rowsPerPage) {
      setRowsPerPage(props?.managerListData?.managerActionsData?.limit);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const requestData = {
      recordPerPage: rowsPerPage,
      sortColumn: orderBy,
      sortOrder: order,
      pageNo: newPage + 1,
    };
    props.getManagerActionsData(requestData);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    const requestData = {
      recordPerPage: parseInt(event.target.value, 10),
      sortColumn: orderBy,
      sortOrder: order,
      pageNo: 1,
    };
    props.getManagerActionsData({ ...requestData });
  };

  rows = [];

  const result = props.managerListData.managerActionsData?.data?.map(
    (items) => ({
      Business_Name: items?.Business_Details?.Business_Name,
      Business_Uid: items?.Business_Details?.uid,
      Email: items?.Email,
      Manager_uid: items.Manager_uid,
      _id: items?._id,
      First_Name: items?.First_Name,
      Last_Name: items?.Last_Name,
      Updated_date: items?.ManagerStatus?.Updated_date,
      Status_Code: items?.ManagerStatus?.Status
        ? items?.ManagerStatus?.Status
        : null,
      User_Id: items.Manager_Details?.User_Id,
      ManagerStatus: items?.ManagerStatus,
      UpdateMgId: items?._id,
      UpdateBsId: items?.Business_Details?._id,
      uniqueId: items?.ManagerStatus?._id,
    })
  );
  const resultWhenId = props.managerListDataById.managerActionsData?.data?.map(
    (items) => ({
      Business_Name: items?.Business_Details?.Business_Name,
      Business_Uid: items?.Business_Details?.uid,
      Email: items?.Email,
      Manager_uid: items.Manager_uid,
      _id: items?._id,
      First_Name: items?.First_Name,
      Last_Name: items?.Last_Name,
      Status_Code: items?.ManagerStatus?.Status
        ? items?.ManagerStatus?.Status
        : null,
      User_Id: items.Manager_Details?.User_Id,
      Updated_date: items?.ManagerStatus?.Updated_date,
      UpdateMgId: items?._id,
      UpdateBsId: items?.Business_Details?._id,
      uniqueId: items?.ManagerStatus?._id,
    })
  );
  const newResult =
    id == null &&
    props.managerListData &&
    props.managerListData?.managerActionsData?.status === true
      ? result
      : resultWhenId;
  if (newResult) {
    newResult.forEach((v) => {
      const Business_Name = v.Business_Name;
      const Business_Uid = v.Business_Uid;
      const Email = v.Email;
      const Updated_date = moment(v.Updated_date)
        .tz("America/New_York")
        .format("MM/DD/YYYY");
      const Manager_name = `${v.First_Name} ${v.Last_Name}`;
      const Manager_uid = v.Manager_uid;
      const Status_Code = v?.ManagerStatus?.Status
        ? v?.ManagerStatus?.Status
        : null;
      const UpdateMgId = v?.UpdateMgId;
      const UpdateBsId = v?.UpdateBsId;
      const uniqueId = v?.uniqueId;
      rows.push(
        createData(
          Business_Name,
          Business_Uid,
          Manager_name,
          Manager_uid,
          Email,
          Updated_date,
          Status_Code,
          UpdateMgId,
          UpdateBsId,
          uniqueId
        )
      );
    });
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";
    setOrder(newOrder);
    setOrderBy(property);
    const requestData = {
      recordPerPage: rowsPerPage,
      sortColumn: property,
      sortOrder: newOrder,
      pageNo: page,
    };
    props.getManagerActionsData(requestData);
  };

  const handleStatusChange = (value, row, serviceCode) => {
    const payload = {
      Business_uid: row.Business_Uid,
      Manager_uid: row.Manager_uid,
      UpdateMgId: row?.UpdateMgId,
      UpdateBsId: row?.UpdateBsId,
      Link: value === "Link",
      Service_Code: row.Status_Code.find(
        (item) => item.Service_Code === serviceCode
      )
        ? serviceCode
        : "",
    };

    setLoading(true);
    props.managerActionsLink(
      payload,
      (res) => {
        setLoading(false);
        if (res.status === true) {
          enqueueSnackbar(`${res.message}`, { variant: "success" });
          const payload = {
            pageNo: page,
            recordPerPage: rowsPerPage,
            sortColumn: orderBy,
            sortOrder: order,
          };
          props.getManagerActionsData(payload);
        }
      },
      (error) => {
        setLoading(false);
        enqueueSnackbar(`${error.message}`, { variant: "error" });
      }
    );
  };

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        enqueueSnackbar(`${text} copied to clipboard`, { variant: "success" });
      })
      .catch(() => {
        enqueueSnackbar("Failed to copy text to clipboard", {
          variant: "error",
        });
      });
  };

  const renderStatusSelect = (
    row,
    serviceCode,
    openDropdown,
    setOpenDropdown
  ) => (
      isArray(row?.Status_Code) &&
      row?.Status_Code?.map((items) =>
        items.Service_Code === serviceCode ? (
          <Select
            key={`${row.uniqueId}-${serviceCode}`}
            value={items.Status || ""}
            open={openDropdown[row.uniqueId] || false}
            onClose={() =>
              setOpenDropdown((prev) => ({
                ...prev,
                [row.uniqueId]: false,
              }))
            }
            onOpen={() =>
              setOpenDropdown((prev) => ({
                ...prev,
                [row.uniqueId]: true,
              }))
            }
            onClick={(e) => {
              const selectedValue = e.target.textContent;
              if (["Link", "Delink"].includes(selectedValue)) {
                handleStatusChange(selectedValue, row, serviceCode);
                setOpenDropdown((prev) => ({
                  ...prev,
                  [row.uniqueId]: false,
                }));
              }
            }}
            className={dropdownClasses.select}
            MenuProps={{ classes: { paper: dropdownClasses.menuPaper } }}
          >
            <MenuItem value={items.Status}>{items.Status}</MenuItem>

            {["Inactive", "Active", "Pending Activation"].includes(
              items.Status
            ) &&
              [
                items.Status === "Inactive" && (
                  <MenuItem
                    key="Link"
                    value="Link"
                    onClick={() => handleStatusChange("Link", row, serviceCode)}
                  >
                    Link
                  </MenuItem>
                ),
                items.Status === "Active" && (
                  <MenuItem
                    key="Delink"
                    value="Delink"
                    onClick={() =>
                      handleStatusChange("Delink", row, serviceCode)
                    }
                  >
                    Delink
                  </MenuItem>
                ),
                items.Status === "Pending Activation" && (
                  <MenuItem
                    key="Link"
                    value="Link"
                    onClick={() => handleStatusChange("Link", row, serviceCode)}
                  >
                    Link
                  </MenuItem>
                ),
              ].filter(Boolean)}
          </Select>
        ) : null)
    );

  return (
    <>
      <AppLoader loader={loading} />
      <TableContainer className={classes.TableContainer} component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <EnhancedTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
          />
          <TableBody>
            {!isEmpty(rows) ? (
              rows.map((row, index) => (
                <TableRow className={classes.cellHeadSign} key={index}>
                  <TableCell className={classes.cellText}>
                    {row.Business_Name}
                  </TableCell>
                  <TableCell className={classes.cellText}>
                    <div onClick={() => copyToClipboard(row.Business_Uid)}>
                      {row.Business_Uid}
                    </div>
                  </TableCell>
                  <TableCell className={classes.cellText} align="left">
                    {row.Manager_name}
                  </TableCell>
                  <TableCell className={classes.cellText} align="left">
                    <div onClick={() => copyToClipboard(row.Manager_uid)}>
                      {row.Manager_uid}
                    </div>
                  </TableCell>
                  <TableCell className={classes.cellText} align="left">
                    {row.Email}
                  </TableCell>
                  <TableCell className={classes.cellText} align="left">
                    {row.Updated_date}
                  </TableCell>

                  <TableCell className={classes.cellText} align="left">
                    {renderStatusSelect(
                      row,
                      "RTP",
                      openDropdownRTP,
                      setOpenDropdownRTP
                    )}
                  </TableCell>

                  <TableCell className={classes.cellText} align="left">
                    {renderStatusSelect(
                      row,
                      "ACH",
                      openDropdownACH,
                      setOpenDropdownACH
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell className="no-data" colSpan={12}>
                  <img
                    src={noDataImage}
                    alt=""
                    className={classes.noDataImage}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          {rows.length ? (
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[
                    5,
                    10,
                    25,
                    {
                      label: "All",
                      value:
                        id == null && props.managerListData
                          ? props.managerListData.managerActionsData?.total
                          : props.managerListDataById.managerListDataById
                              ?.total,
                    },
                  ]}
                  colSpan={12}
                  count={
                    id == null && props.managerListData
                      ? props.managerListData.managerActionsData?.total
                      : props.managerListDataById.managerListDataById?.total
                  }
                  rowsPerPage={rowsPerPage || 5}
                  page={page - 1}
                  SelectProps={{
                    inputProps: { "aria-label": "rows per page" },
                    MenuProps: { classes: { paper: classes.selectDropdown } },
                  }}
                  classes={{ menuItem: classes.menuItem }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          ) : (
            ""
          )}
        </Table>
      </TableContainer>
    </>
  );
};

ManagerActions.propTypes = {
  tableData: PropTypes.object,
  history: PropTypes.any,
  userDetails: PropTypes.object,
  mainData: PropTypes.object,
  getMerchantListData: PropTypes.func,
  getManagerListData: PropTypes.func,
  getManagerListDataByID: PropTypes.func,
  sendInviteApiCall: PropTypes.func,
  emptyReduxState: PropTypes.func,
  sendInviteManagerApiCall: PropTypes.func,
  getManagerActionsData: PropTypes.func,
  managerActionsLink: PropTypes.func,
};

const mapStateToProps = (app) => ({
  tableData: app.provideRegistration,
  userDetails: app.app,
  mainData: app,
  roles: app.roles,
  merchantListData: app.merchantInformation,
  managerListData: app.merchantInformation,
  managerListDataById: app.merchantInformation,
});
export default connect(mapStateToProps, {
  getMerchantListData,
  getManagerListData,
  getManagerListDataByID,
  sendInviteApiCall,
  emptyReduxState,
  sendInviteManagerApiCall,
  getManagerActionsData,
  managerActionsLink,
})(ManagerActions);
